import React from "react";
import { whoWeHelpData } from "./data";
import "../assests/CSS/AboutComponent3.css";

const AboutComponent3 = () => {
  return (
    <section className="about3-section">
      <h2 className="about3-title">Who We Help</h2>
      <div className="about3-container">
        {whoWeHelpData.map((item) => (
          <div key={item.id} className="about3-card">
                        <h3 className="about3-card-title">{item.title}</h3>
            <div className="about3-icon">
              <img src={item.icon} alt={item.title} />
            </div>

            <p className="about3-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutComponent3;
